export const PACKAGES = [
  {
    id:'starter', label:'Starter', price:'Free to launch', monthly:'€30', popular:false,
    color:'#64748b',
    tagline:'Everything you need to get started.',
    features:[
      'Phone Payments','Booking & Scheduling',
      'Chamcore subdomain hosting','Site content editor',
    ],
    not:['Chamcore PBX / IVR','Video Streaming','Sales Agent Portal','Custom domain'],
  },
  {
    id:'professional', label:'Professional', price:'€49/mo', monthly:'€49', popular:true,
    color:'#3b82f6',
    tagline:'For growing businesses that need more.',
    features:[
      'Everything in Starter','Unlimited agents',
      'Custom domain','IVR & smart call routing',
      'Video & event streaming','Advanced analytics',
      'REST API (read)','Priority support',
    ],
    not:[],
  },
  {
    id:'enterprise', label:'Enterprise', price:'€149/mo', monthly:'€149', popular:false,
    color:'#c084fc',
    tagline:'Full platform control for large teams.',
    features:[
      'Everything in Professional','White-label platform',
      'Full API + webhooks','Custom integrations',
      'Chamcore AI routing','Hedera blockchain audit',
      'Dedicated account manager','99.9% uptime SLA',
      'On-premise option',
    ],
    not:[],
  },
];

export const ADDONS = [
  { id:'vipps',  icon:'🟣', label_key:'a_vipps_lbl',  sub_key:'a_vipps_sub',  nok:299, eur:29,  cat:'pay' },
  { id:'stripe', icon:'💳', label_key:'a_stripe_lbl', sub_key:'a_stripe_sub', nok:199, eur:19,  cat:'pay' },
  { id:'ivr',    icon:'📞', label_key:'a_ivr_lbl',    sub_key:'a_ivr_sub',    nok:499, eur:49,  cat:'svc' },
  { id:'social', icon:'📱', label_key:'a_social_lbl', sub_key:'a_social_sub', nok:299, eur:29,  cat:'svc' },
];

export const PKG_TEXT = {
  starter:      '#94a3b8',
  professional: '#60a5fa',
  enterprise:   '#a78bfa',
};

export const COMPARE = [
  { cat:'Payments', rows:[
    { label:'Vipps (Norway)',                    s:true,  p:true,  e:true  },
    { label:'Card payments (Norwegian + intl.)', s:true,  p:true,  e:true  },
    { label:'Auto-invoicing per call',           s:true,  p:true,  e:true  },
    { label:'130+ currencies',                   s:false, p:true,  e:true  },
  ]},
  { cat:'Agents & capacity', rows:[
    { label:'Up to 3 agents',                   s:true,  p:false, e:false },
    { label:'Unlimited agents',                  s:false, p:true,  e:true  },
    { label:'Callback queue',                    s:false, p:true,  e:true  },
  ]},
  { cat:'Communication', rows:[
    { label:'Dashboard — calls, payments, summary', s:true, p:true, e:true },
    { label:'IVR & smart call routing',          s:false, p:true,  e:true  },
    { label:'Video & event streaming',           s:false, p:true,  e:true  },
  ]},
  { cat:'API & integrations', rows:[
    { label:'REST API (read)',                   s:false, p:true,  e:true  },
    { label:'Full API + webhooks + event streams', s:false, p:false, e:true },
    { label:'Custom integrations (ERP, CRM, accounting)', s:false, p:false, e:true },
    { label:'White-label platform',              s:false, p:false, e:true  },
  ]},
  { cat:'AI & blockchain', rows:[
    { label:'Chamcore AI routing & call scoring', s:false, p:false, e:true },
    { label:'Hedera blockchain audit trail',     s:false, p:false, e:true  },
    { label:'On-premise deployment',             s:false, p:false, e:true  },
  ]},
  { cat:'Support & SLA', rows:[
    { label:'GDPR-certified processing',         s:true,  p:true,  e:true  },
    { label:'Email support (1 business day)',    s:true,  p:false, e:false },
    { label:'Priority support (same day)',       s:false, p:true,  e:false },
    { label:'Dedicated account manager',         s:false, p:false, e:true  },
    { label:'99.9% uptime SLA',                 s:false, p:false, e:true  },
  ]},
];

// Returns the monthly addon total for a set of selected addon IDs
export function addonTotalFor(selectedIds, lang) {
  const useNok = ['no','da','sv'].includes(lang);
  return selectedIds.reduce((sum, id) => {
    const a = ADDONS.find(x => x.id === id);
    return sum + (a ? (useNok ? a.eur : a.eur) : 0);
  }, 0);
}

export function walletLabel(l) {
  if (l === 'en-us') return 'CashApp · Card';
  if (l === 'en')    return 'Apple Pay · Google Pay · Card';
  if (l === 'sv')    return 'Vipps · Swish · Kort';
  if (l === 'no')    return 'Vipps · Kort';
  if (l === 'da')    return 'Vipps · Kort';
  if (l === 'es')    return 'Bizum · Tarjeta';
  if (l === 'nl')    return 'iDEAL · Kaart';
  if (l === 'de')    return 'Apple Pay · Google Pay · Karte';
  return 'Card';
}
